<template>
  <pt-claim-lifeban class="pt-claim-lifeban__page"></pt-claim-lifeban>
</template>

<script>
import PtClaimLifeban from 'cps/insurance-claims/pt-claim-application/withData'
export default {
  name: 'pt-claim-lifeban__view',
  components: {
    'pt-claim-lifeban': PtClaimLifeban
  }
}
</script>
